import { memo, useEffect, useState } from 'react';
import { useSelector } from 'store';
import { fetchAccountSettingsSelector } from 'store/state/dsaSelector';
import mehuna from 'assets/images/mehuna-logo-white.png';
import LazyImage from 'views/components/LazyImage';

const Logo = ({sx}: {sx?: any}) => {
    const accountSettings = useSelector(fetchAccountSettingsSelector);
    const [logoImage, setLogoImage] = useState<string>(mehuna);

    useEffect(() => {
        if (accountSettings?.logoImage) {
            setLogoImage(accountSettings.logoImage);
        }
    }, [accountSettings]);

    return (
        <LazyImage
            src={logoImage}
            alt={accountSettings?.alt || "Mehuna"}
            width="200"
            height="50"
            style={{ objectFit: 'contain', ...sx }}
        />
    );
};

export default memo(Logo);
